export default function registerSetting (lf) {
  lf.register('setting', ({ PolygonNode, PolygonNodeModel, h }) => {
    class Node extends PolygonNode {
      getIconShape () {
        const {model} = this.props
        const {x,y,width, height} = model
        const {stroke} = model.getNodeStyle()
        return h(
          "svg",{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink",x:width/2-25,y:height/2-25,"width":"50","height":"50","viewBox":"0 0 40 40","fill":"none"},
          h("g",{"opacity":"1","transform":"translate(0 0)  rotate(0 20 20)"}),
          h("g",{"mask":"url(#bg-mask-0)"}),
          h("path",{"id":"分组 2","fill-rule":"evenodd","style":"fill:#2A82E4","transform":"translate(14.124999999999966 14.113281249999982)  rotate(0 5.90234375 5.90234375)","opacity":"1","d":"M11.8 5.9C11.8 2.65 9.16 0 5.9 0C2.65 0 0 2.65 0 5.9C0 9.16 2.65 11.8 5.9 11.8C9.16 11.8 11.8 9.16 11.8 5.9Z M2.66406 5.90406C2.66406 7.68406 4.11406 9.14406 5.90406 9.14406C7.68406 9.14406 9.14406 7.68406 9.14406 5.90406C9.14406 4.11406 7.69406 2.66406 5.90406 2.66406C4.11406 2.66406 2.66406 4.11406 2.66406 5.90406Z "}),
          h("path",{"id":"分组 1","fill-rule":"evenodd","style":"fill:#2A82E4","transform":"translate(1.6435546874999325 3.8398437499999822)  rotate(0 18.3857421875 16.1796875)","opacity":"1","d":"M26.62 32.36C27.3 32.36 27.94 31.99 28.28 31.4L36.52 17.14C36.86 16.55 36.86 15.81 36.52 15.22L28.28 0.96C27.94 0.37 27.31 0 26.62 0L10.15 0C9.47 0 8.83 0.37 8.49 0.96L0.25 15.22C-0.08 15.81 -0.08 16.55 0.25 17.14L8.49 31.4C8.83 31.99 9.47 32.36 10.15 32.36L26.62 32.36Z M26.1844 29.7002L33.9944 16.1802L26.1844 2.66016L10.5744 2.66016L2.77441 16.1802L10.5744 29.7002L26.1844 29.7002Z "}),
          h("mask",{"id":"bg-mask-0","fill":"white"}),
          h("use",{"xlink:href":"#path_0"}),
          h("rect",{"id":"path_0","x":"0","y":"0","width":"40","height":"40"}),

        )
      }
      getShape () {
        const {model} = this.props
        const {width, height, x, y, points} = model
        const {fill, fillOpacity, strokeWidth, stroke, strokeOpacity,} = model.getNodeStyle()
        const transform = `matrix(1 0 0 1 ${x - width / 2} ${y - height / 2})`
        const pointsPath = points.map(point => point.join(',')).join(' ')
        return h(
          'g',
          {
            transform
          },
          [
            h("svg",{"xmlns":"http://www.w3.org/2000/svg","version":"1.1"}),
            h("rect",{"width":width,"height":height,"style":"fill:#ffffff;stroke-width:1;stroke:#aaaaaa;"}),
            this.getIconShape()
          ]
        )
      }
    }
    class Model extends PolygonNodeModel {
      constructor (data, graphModel) {
        data.text = {
          value: (data.text && data.text.value) || '',
          x: data.x,
          y: data.y + 50
        }
        super(data, graphModel)
        // 右键菜单自由配置，也可以通过边的properties或者其他属性条件更换不同菜单
        this.menu = [
          {
            className: 'lf-menu-delete',
            text: '删除',
            callback (node) {
              // const comfirm = window.confirm('你确定要删除吗？')
              lf.deleteNode(node.id)
            }
          },
          {
            text: '修改',
            className: 'lf-menu-item',
            callback (node) {
              lf.editText(node.id)
            }
          },
          {
            text: '复制',
            className: 'lf-menu-item',
            callback (node) {
              lf.cloneNode(node.id)
            }
          }
        ]
      }
      initNodeData(data) {
        super.initNodeData(data)
        const lenght = 35
        this.points = [
          [lenght, 0],
          [lenght * 2, lenght],
          [lenght, lenght * 2],
          [0, lenght]
        ]
      }
      // 自定义锚点样式
      getAnchorStyle() {
        const style = super.getAnchorStyle();
        style.hover.r = 8;
        style.hover.fill = "rgb(24, 125, 255)";
        style.hover.stroke = "rgb(24, 125, 255)";
        return style;
      }
    }
    return {
      view: Node,
      model: Model
    }
  })
}



// WEBPACK FOOTER //
// ./src/components/Admin/Flow/bpmn/registerNode/registerSetting.js